import 'firebase/firestore';

export default {
  name: 'OtherBundle',
  props: {
    settings: null,
    arecheckedesdisabled: Boolean,
    facility: null
  },
  created() {
    this.sendDefaultValueForModule();
  },
  computed: {
    otherBundle: {
      get() {
        return this.entertainmentCategory && this.otherCategory;
      }
    },
    entertainmentCategory: {
      get() {
        return (
          (this.facility.contentLibraryEnabled ?? true) &&
          (this.facility.isStaffHubContentManagerMediaLibrary ?? true)
        );
      }
    },
    otherCategory: {
      get() {
        return (
          (this.facility.allowWiFiSetting ?? true) &&
          (this.facility.isStaffHubReporting ?? true)
        );
      }
    },

  },
  watch: {
    otherBundle() {
      this.$emit('send-bundle-value', this.otherBundle)
    }
  },
  methods: {
    sendDefaultValueForModule() {
      this.$emit('send-bundle-value', this.otherBundle)
    },
    otherBundleUpdate(value) {
      this.entertainmentCategory = value;
      this.otherCategory = value;
      this.entertainmentCategoryUpdate(value);
      this.otherCategoryUpdate(value);
    },
    entertainmentCategoryUpdate(value) {
      this.facility.contentLibraryEnabled = value;
      this.facility.isStaffHubContentManagerMediaLibrary = value;
    },
    otherCategoryUpdate(value) {
      this.facility.allowWiFiSetting = value;
      this.facility.isStaffHubReporting = value;
    }
  }
};